import { FilterSettings } from 'components/tables/Table.interfaces';
import {
	Subscription,
	SubscriptionStatus,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';

export const columnFilters: FilterSettings<Subscription> = {
	treatGroupsAsSingle: false,
	groups: [
		{
			columnId: 'status',
			filters: [
				{
					text: 'Active',
					value: [
						SubscriptionStatus.Active,
						SubscriptionStatus.Ordered,
					],
					selected: true,
				},
				{
					text: 'Inactive',
					value: [
						SubscriptionStatus.Canceled,
						SubscriptionStatus.Expired,
					],
					selected: false,
				},
				{
					text: 'All',
					value: undefined,
					selected: false,
				},
			],
		},
		{
			columnId: 'type',
			filters: [
				{
					text: 'Paid',
					value: [SubscriptionType.Paid],
					selected: true,
				},
				{
					text: 'Trial',
					value: [SubscriptionType.Trial],
					selected: false,
				},
				{
					text: 'Free',
					value: [SubscriptionType.Free],
					selected: false,
				},
				{
					text: 'Internal',
					value: [SubscriptionType.Internal],
					selected: false,
				},
				{
					text: 'All',
					value: undefined,
					selected: false,
				},
			],
		},
	],
};
